import qs from 'qs';

const axios = window.axios;
const $ = window.$;
const _ = window._;

$(() => {
  const $passwordCheckerResult = $('.page_password_checker .password_checker_result');
  const $passwordCheckerResultText = $('.page_password_checker .password_checker_result_text');

  const displayFunc = ({isError, message, loading = false}) => {
    const $passwordCheckerInput = $('.page_password_checker .password_checker_input');

    if (loading) {
      $passwordCheckerInput.addClass('loading');
    } else {
      $passwordCheckerInput.removeClass('loading');
      $passwordCheckerResultText.text(message);
      if (isError) {
        $passwordCheckerInput.addClass('error');
        $passwordCheckerInput.removeClass('is-valid');
        $passwordCheckerResult.addClass('badresult-text');
        if (typeof ga !== 'undefined') {
          ga('send', 'event', 'password_error', 'Password validation Error', location.href, {nonInteraction: true});
        }
      } else {
        $passwordCheckerInput.addClass('is-valid');
        $passwordCheckerInput.removeClass('error');
        $passwordCheckerResult.removeClass('badresult-text');
        if (typeof ga !== 'undefined') {
          ga('send', 'event', 'password_valid', 'Password validation OK', location.href, {nonInteraction: true});
        }
      }
    }
    if ($('.page_password_checker .password_checker_user_name').hasClass('is-valid')
      && $('.page_password_checker .password_checker_email').hasClass('is-valid')
      && $('.page_password_checker .password_checker_input').hasClass('is-valid')) {
      $('.signup-btn-form-submit').attr('disabled', false);
    }
  };

  let cancelRequest = null;
  const passwordValidateFunc = _.debounce(async(password, username, email) => {
    // 前回のリクエストをキャンセルする
    if (cancelRequest) {
      cancelRequest();
    }
    try {
      displayFunc({loading: true});
      const data = {
        password: password,
        user_name: username,
        email: email
      };
      const options = {
        method: 'POST',
        headers: {'content-type': 'application/x-www-form-urlencoded'},
        data: qs.stringify(data),
        cancelToken: new axios.CancelToken(c => { cancelRequest = c; }),
        url: '/signup/password/validate'
      };
      const {data: {errors} } = await axios(options);
      if (errors) {
        displayFunc({isError: true, message: errors[0].message});
      } else {
        displayFunc({isError: false, message: ''});
      }
    } catch (e) {
      // 何もしない
    }
  }, 150);

  let keepPasswordValue = '';
  const passwordCheckFunc = () => {
    const $passwordCheckerInput = $('.page_password_checker .password_checker_input');
    const password = $passwordCheckerInput.val();
    const username = $('.page_password_checker .password_checker_user_name').val();
    const email = $('.page_password_checker .password_checker_email').val();

    if (!password || !password.length) {
      displayFunc({isError: true, message: 'Please enter your password.'});
      return;
    }
    if (keepPasswordValue == password) {
      return;
    }

    passwordValidateFunc(password, username, email);
  };

  const setPasswordCheckFunc = ($element) => {
    $element.on('blur', passwordCheckFunc);
  };
  const passwordKeepFunc = () => {
    keepPasswordValue = $('.page_password_checker .password_checker_input').val();
  };
  const setPasswordKeepFunc = ($element) => {
    $element.on('focus', passwordKeepFunc);
  };

  setPasswordCheckFunc($('.page_password_checker .password_checker_input'));
  setPasswordKeepFunc($('.page_password_checker .password_checker_input'));

  const showPasswordToggleFunc = ($password) => {
    const passwordStr = $password.val();

    let type;
    if ($password.attr('type') === 'text') {
      type = 'password';
    } else {
      type = 'text';
    }

    const $newPassword = $('<input>');
    $newPassword.attr('type', type);
    $newPassword.attr('value', passwordStr);
    _.each(['id', 'class', 'name', 'size', 'maxlength', 'tabindex', 'autocomplete', 'placeholder'], (value, key) => {
      const attr = $password.attr(value);
      if (attr) {
        $newPassword.attr(value, $password.attr(value));
      }
    });

    $password.before($newPassword);
    $password.remove();

    return $newPassword;
  };

  $('.page_password_checker #show-password').change(() => {
    const $showPassword = $(this);

    const $password0 = $('.page_password_checker #password');
    if ($password0) {
      const $newPassword0 = showPasswordToggleFunc($password0, $showPassword);
      setPasswordCheckFunc($newPassword0);
    }

    const $password1 = $('.page_password_checker #new-password');
    if ($password1) {
      const $newPassword1 = showPasswordToggleFunc($password1, $showPassword);
      setPasswordCheckFunc($newPassword1);
    }

    const $password2 = $('.page_password_checker #confirm-new-password');
    if ($password2) {
      showPasswordToggleFunc($password2, $showPassword);
    }

    const $password3 = $('.page_password_checker #current-password');
    if ($password3) {
      showPasswordToggleFunc($password3, $showPassword);
    }
  });

  $('.page_password_checker #show-password-sp').click(() => {
    const $showPassword = $(this);

    const $password = $('.page_password_checker #password');
    if ($password) {
      const $newPassword = showPasswordToggleFunc($password, $showPassword);
      setPasswordCheckFunc($newPassword);
    }

    $(this).toggleClass('checked');
  });

  $('#create-account').click(function() {
    if (typeof ga !== 'undefined') {
      ga('send', 'event', 'signup_submit', 'Signup Create Account', location.href, {nonInteraction: true});
    }
    $('#create-account').submit();
  });
});
